/* src/app/tip-ticket/pages/tip-ticket-delete/tip-ticket-delete.component.scss */
/*# sourceMappingURL=tip-ticket-delete.component.css.map */
